<template>

    <Head title="ASF" />

    <section>
        <Header/>
    </section>

    <section>
        <slot/>
    </section>

    <section>
        <Footer/>
    </section>

</template>

<script>


import Header from "./Header";
import Footer from "./Footer";

export default {
    name: "Layout",

    components: {
        Header,
        Footer,
    }
}
</script>

<style scoped>

</style>
